import { render, staticRenderFns } from "./Splitbutton.vue?vue&type=template&id=fc846f48&"
import script from "./Splitbutton.vue?vue&type=script&lang=js&"
export * from "./Splitbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports